import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import usePopupPage from "../PopupPage";
import { colors } from "src/styles/theme";
import { recoilStates } from "src/recoil/recoilStates";
import { useRecoilState } from "recoil";
import { parseJsonStr } from "src/utils";
import { dateFormat } from "src/utils";
import STATIC_DATA from "src/staticData";
import { SreenCoverLoading } from "src/components";
import { createTeeshotAxiosInstance } from "src/http";
// import checkCircle from "../../assets/images/check_circle.svg";
// import checkCircleOff from "../../assets/images/check_circle-off.svg";
import SignModalContent from "./SignModalContent2";
import AlertModal from "./components/common/AlertModal";
import { useAlert } from "src/hooks";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

export default function HasProposal() {
  const [bookingApplication, setBookingApplication] = useRecoilState(
    recoilStates.bookingApplication
  );
  const [group] = useRecoilState(recoilStates.group);
  const [user] = useRecoilState(recoilStates.user);
  const [expandedSchedules, setExpandedSchedules] = useState<{ [key: number]: boolean }>({});
  const [selectedClubRelId, setSelectedClubRelId] = useState<number>(0);
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [isFloatingBottomShow, setIsFloatingBottomShow] = useState(false);
  const [isSignModalOpened, setIsSignModalOpened] = useState(false);
  const [signBase64, setSignBase64] = useState<string | null>(null);
  const [selectedClubInfo, setSelectedClubInfo] = useState<any>(null);
  const [coverLoadingState, setCoverLoadingState] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const alert = useAlert();

  const { PopupComponent, openPopup } = usePopupPage("announceInConfirmSection"); //약관
  // 신청 직후 1, 조건제시 3, 클럽거절7
  const clubRels = bookingApplication?.clubRels
    ?.filter((c) => [1, 3, 7].includes(c?.year_booking_status_id))
    .sort((a, b) => (a.year_booking_status_id === 3 ? -1 : 1));

  const rejectedRels = bookingApplication?.clubRels?.filter(
    (cr) => cr.year_booking_status_id === 7
  );
  const accectedRels = bookingApplication?.clubRels?.filter(
    (cr) => cr.year_booking_status_id === 3
  );

  console.log("bookingApplication.hopeDates", bookingApplication?.hopeDates);
  console.log("bookingApplication.clubRels", bookingApplication?.clubRels);

  const myMemberData = group.members.find((m) => {
    return m.teeshot_user_id && m.teeshot_user_id === user.id;
  });
  const etcRequirements = bookingApplication?.etcRequirements?.length
    ? bookingApplication?.etcRequirements
    : null;
  const isGroupOfficer = [1, 2, 4].includes(myMemberData?.booking_group_member_level_id || 0);

  const navigate = useNavigate();

  const toggleSchedule = (clubId: number) => {
    setExpandedSchedules((prev) => ({
      ...prev,
      [clubId]: !prev[clubId],
    }));
  };

  console.log("bookingApplication", group);
  const handleConfirmClick = (clubId: number) => {
    setSelectedClubRelId(clubId);
    const rel = bookingApplication?.clubRels?.find((cr) => cr?.id === clubId);
    // In other screens we use rel.club?.[0] as the detail object for rules
    setSelectedClubInfo(rel?.club?.[0] || null);
    setIsFloatingBottomShow(true);
  };

  const handleConfirm = async () => {
    if (!selectedClubRelId || !signBase64) {
      alert("서명을 입력하세요.");
      return;
    }

    setCoverLoadingState(true);
    try {
      const res = await createTeeshotAxiosInstance().post("/yearBooking/booking/confirmClub", {
        clubRelId: selectedClubRelId,
        signBase64,
      });
      if (!res.data?.success || !res?.data?.data?.newClubRels?.length) {
        throw new Error(res?.data?.message);
      }
      const rels = res?.data?.data?.newClubRels;

      // 서명 모달을 닫고 성공 모달을 표시
      setIsSignModalOpened(false);
      setSignBase64(null);
      setTimeout(() => {
        setShowSuccessModal(true);
      }, 100);

      // 상태 업데이트는 성공 모달에서 처리하도록 주석 처리
      // setBookingApplication((prev) => {
      //   if (!prev) return null;
      //   return { ...prev, clubRels: rels } as any;
      // });
    } catch (e) {
      alert({
        content: `확정 요청 실패: ${String(e)}`,
        onClose: () => {
          alert.resume();
        },
      });
      await alert.pause();
    } finally {
      setCoverLoadingState(false);
    }
  };

  useEffect(() => {
    if (!selectedClubRelId) {
      return;
    }
    const rel = bookingApplication?.clubRels?.find((cr) => cr?.id === selectedClubRelId);
    setSelectedClubInfo(rel?.club?.[0] || null);
  }, [selectedClubRelId, bookingApplication]);

  console.log("selectedClubInfo", selectedClubInfo);
  return (
    <>
      <Container>
        {/* Main Content */}
        <div className="main-content">
          <div className="approval-header">
            <span className="approval-text">승인 골프장 </span>
            <span className="approval-count">{accectedRels?.length || 0}</span>
            <span className="approval-text">개</span>
          </div>

          {/* Main Reservation Cards */}
          {clubRels?.map((cr, idx) => {
            const isActiveProposal = cr.year_booking_status_id === 3;
            const isRejectedProposal = cr.year_booking_status_id === 7; //승인 거절
            const isReviewing = cr.year_booking_status_id === 1;
            const isExpanded = expandedSchedules[cr.id || 0];

            const clubName = cr.club?.name;
            const club = cr.club?.[0];
            const reservationAgent1Name = club?.reservationAgent1;
            const reservationAgent1Tel = club?.reservationAgentTel1;
            const reservePhone = club?.reserve_phone || club?.phone;
            const hasAgentData = reservationAgent1Name && reservationAgent1Tel;
            const hasPhone = Boolean(reservePhone);

            if (isActiveProposal) {
              // hopeDates와 clubRels 데이터 비교 (1지망 또는 2지망 중 하나라도 맞으면 승락)
              const isDataMatch = bookingApplication?.hopeDates?.some(
                (hopeData) =>
                  hopeData.day_arr_json_str === cr.day_arr_json_str &&
                  hopeData.month_arr_json_str === cr.month_arr_json_str &&
                  hopeData.week_arr_json_str === cr.week_arr_json_str &&
                  hopeData.start_time === cr.start_time
              );

              return (
                <div
                  key={`reservation-card-${cr.id}-${idx}`}
                  className="reservation-card main-card"
                >
                  <div className="card-header">
                    <h3 className="golf-course-name">{cr.name}</h3>
                    <div className={`status-badge ${isDataMatch ? "approved" : "modified"}`}>
                      {isDataMatch ? "신청 승낙" : "조건 변경"}
                    </div>
                  </div>

                  <div className="card-info">
                    {(cr.round_deposit ?? 0) > 0 && (
                      <div className="info-row">
                        <span className="info-label">보증금</span>
                        <span className="info-value">
                          {cr.round_deposit?.toLocaleString() + " 원"}
                        </span>
                      </div>
                    )}
                    <div className="info-row">
                      <span className="info-label">객단가</span>
                      <span className="info-value">
                        {cr.meal_price_per_person
                          ? cr.meal_price_per_person?.toLocaleString() + " 원"
                          : " - "}
                      </span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">
                        그린피
                        <span
                          className="golf-course-note"
                          style={{
                            marginLeft: "8px",
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "#79818a",
                          }}
                        >
                          *골프장 상황에 따라 변동
                        </span>
                      </span>
                      <span className="info-value">
                        {cr.year_booking_round_dates?.[0]?.green_fee
                          ? cr.year_booking_round_dates[0].green_fee?.toLocaleString() + " 원"
                          : " - "}
                      </span>
                    </div>
                  </div>

                  <div className="schedule-details">
                    <div className="schedule-header" onClick={() => toggleSchedule(cr.id || 0)}>
                      <span className="schedule-title">일정 및 그린피 보기</span>
                      <svg
                        width="10"
                        height="7"
                        viewBox="0 0 10 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`chevron-icon ${isExpanded ? "expanded" : ""}`}
                      >
                        <path
                          d="M5 2.47226L1.78151 5.86956C1.44745 6.22217 0.885883 6.22217 0.551825 5.86956C0.242354 5.54289 0.242354 5.03126 0.551825 4.70459L4.49875 0.538393C4.77109 0.250921 5.22891 0.250921 5.50125 0.538393L9.44818 4.70459C9.75765 5.03126 9.75765 5.54289 9.44818 5.86956C9.11412 6.22217 8.55255 6.22217 8.21849 5.86956L5 2.47226Z"
                          fill="#79818A"
                        />
                      </svg>
                    </div>

                    {isExpanded && (
                      <div className="schedule-info">
                        <div className="schedule-section">
                          <div className="schedule-section">
                            <div className="facility-section">
                              <TextWeight700>
                                {JSON.parse(cr?.week_arr_json_str || "[]")?.join("주차, ")}주
                                {" " + JSON.parse(cr?.day_arr_json_str || "[]")?.join("요일")}요일{" "}
                                {cr?.start_time?.slice(0, 2)}:{cr?.start_time?.slice(2, 4)}
                              </TextWeight700>
                              <MonthButtonContainer>
                                {(() => {
                                  const months = parseJsonStr(cr?.month_arr_json_str ?? "[]");
                                  if (!months || months.length === 0) return <div> - </div>;
                                  return months
                                    .map((num: any) => +num)
                                    .sort((a: number, b: number) => a - b)
                                    .map((m: number) => (
                                      <MonthButton key={m} className="ml-2 fw-n">
                                        {m}월
                                      </MonthButton>
                                    ));
                                })()}
                              </MonthButtonContainer>
                            </div>
                          </div>
                        </div>
                        <div className="facility-section pl-2 pr-2">
                          <div className="round-details">
                            {cr.year_booking_round_dates?.map((rd: any, roundIdx: number) => (
                              <div key={`round-${roundIdx}`} className="round-item">
                                <h5 className="round-date">
                                  {dateFormat(new Date(rd.round_date)) +
                                    " " +
                                    cr?.start_time?.slice(0, 2)}
                                  :{cr?.start_time?.slice(2, 4)}{" "}
                                </h5>
                                <div className="round-pricing">
                                  <div className="pricing-row">
                                    <span className="pricing-label">그린피</span>
                                    <span className="pricing-value">
                                      {rd.green_fee?.toLocaleString()} 원
                                    </span>
                                  </div>
                                  <div className="pricing-row">
                                    <span className="pricing-label">카트피</span>
                                    <span className="pricing-value">
                                      {rd.cart_fee?.toLocaleString()} 원
                                    </span>
                                  </div>
                                  <div className="pricing-row">
                                    <span className="pricing-label">캐디피</span>
                                    <span className="pricing-value">
                                      {rd.caddy_fee?.toLocaleString()} 원
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="facility-section">
                          <h4 className="section-title">시설이용</h4>
                          <div className="facility-info">
                            <div className="facility-row">
                              <span className="facility-label">결제방식</span>
                              <span className="facility-value">
                                {STATIC_DATA.PAY_TYPE_DATA.find(
                                  (d) => d.id === bookingApplication?.payment_type_id
                                )?.name || " - "}
                              </span>
                            </div>
                            <div className="facility-row">
                              <span className="facility-label">식사 선택</span>
                              <span className="facility-value">
                                {STATIC_DATA.MEAL_TYPE_DATA.find(
                                  (d) => d.id === bookingApplication?.meal_type_id
                                )?.name || " - "}
                              </span>
                            </div>
                            <div className="facility-row">
                              <span className="facility-label">프로샵 이용</span>
                              <span className="facility-value">
                                {bookingApplication?.proshop_item || " - "}
                              </span>
                            </div>
                            <div className="facility-row">
                              <span className="facility-label">룸 이용</span>
                              <span className="facility-value">
                                {(() => {
                                  const roomTypeId =
                                    cr?.year_booking_round_dates?.[0]?.room_type_id;
                                  if (roomTypeId === null || roomTypeId === undefined) return " - ";
                                  return roomTypeId === 1
                                    ? "라운드 전"
                                    : roomTypeId === 2
                                    ? "라운드 후"
                                    : " - ";
                                })()}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="game-section">
                          <h4 className="section-title">경기 및 시상</h4>
                          <div className="game-info">
                            <div className="game-row">
                              <span className="game-label">경기방식</span>
                              <span className="game-value">
                                {
                                  STATIC_DATA.GAME_TYPE_DATA.find((d) => {
                                    return d.id === bookingApplication?.game_type_id;
                                  })?.name
                                }
                              </span>
                            </div>
                            <div className="game-row">
                              <span className="game-label">티 사용</span>
                              <span className="game-value">
                                {
                                  STATIC_DATA.TEEBOX_TYPE_DATA.find((d) => {
                                    return d.id === bookingApplication?.teebox_type_id;
                                  })?.name
                                }
                              </span>
                            </div>
                            <div className="game-row">
                              <span className="game-label">시상내용</span>
                              <span className="game-value">
                                {(() => {
                                  const awardIds = parseJsonStr(
                                    bookingApplication?.award_ids_arr_json_str ?? ""
                                  );
                                  const hasAwards = awardIds && awardIds.length > 0;
                                  if (hasAwards) {
                                    const awards = STATIC_DATA.AWARDS_DATA.filter((d) => {
                                      return awardIds.includes(d.id);
                                    });
                                    return awards
                                      ?.map((a) => {
                                        return a.name;
                                      })
                                      .join(", ");
                                  }
                                  return " - ";
                                })()}
                              </span>
                            </div>
                            <div className="game-row">
                              <span className="game-label">요청사항</span>
                              <span className="game-value">
                                {" "}
                                {etcRequirements
                                  ? etcRequirements.map((e) => e.name)?.join(", ")
                                  : " - "}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="notice-section">
                          <h4 className="section-title">안내사항</h4>
                          <p className="notice-content">{cr?.etc_notification || " - "}</p>
                        </div>

                        <div className="contact-section">
                          <p className="contact-info">
                            {(() => {
                              if (hasAgentData) {
                                return `예약담당자 ${reservationAgent1Name}: ${reservationAgent1Tel}`;
                              }
                              if (hasPhone) {
                                return `예약연락처: ${reservePhone}`;
                              }
                              return "티샷: 02-2277-3489";
                            })()}
                          </p>
                          <p className="disclaimer">
                            *상기 비용은 골프장의 상황에 따라 변경될 수 있고, 문의가 필요한 경우
                            전화로 협의해 주시기 바랍니다.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    className="confirm-button"
                    disabled={!isGroupOfficer}
                    onClick={() => {
                      setSelectedClubRelId(cr.id || 0);
                      const rel = bookingApplication?.clubRels?.find(
                        (cr_rel) => cr_rel?.id === cr.id
                      );
                      setSelectedClubInfo(rel?.club?.[0] || null);
                      setIsSignModalOpened(true);
                    }}
                  >
                    예약 확정
                  </button>
                </div>
              );
            }

            if (isReviewing) {
              return (
                <div key={`status-card-${cr.id}-${idx}`} className="reservation-card status-card">
                  <div className="card-header">
                    <h3 className="golf-course-name">{cr.name}</h3>
                    <div className="status-badge reviewing">검토중</div>
                  </div>
                  <p className="status-message">신청하신 조건을 골프장에서 검토중입니다.</p>
                </div>
              );
            }

            if (isRejectedProposal) {
              return (
                <div key={`status-card-${cr.id}-${idx}`} className="reservation-card status-card">
                  <div className="card-header">
                    <h3 className="golf-course-name">{cr.name}</h3>
                    <div className="status-badge unavailable">신청 거절</div>
                  </div>
                  <p className="status-message">골프장에서 수락을 거절했습니다.</p>
                </div>
              );
            }

            return null;
          })}
        </div>
      </Container>
      {isSignModalOpened && (
        <>
          <SignModalContent
            type={2} // 1:신청(개인) , 2: 확정(단체)
            groupName={group?.name}
            setSignBase64={setSignBase64}
            name={user?.realname}
            setModalState={setIsSignModalOpened}
            onConfirm={handleConfirm}
            rejectConfirmCondition={Boolean(!signBase64)}
          />
        </>
      )}
      {coverLoadingState && <SreenCoverLoading />}

      {/* 성공 AlertModal */}
      {showSuccessModal && (
        <div style={{ zIndex: 10 }}>
          <AlertModal
            onClose={() => setShowSuccessModal(false)}
            title="예약 확정"
            subtitle="연 단체 예약이 확정되었습니다."
            confirmText="확인"
            onConfirm={() => {
              setShowSuccessModal(false);
              navigate("/");
              window.location.reload();
            }}
          />
        </div>
      )}

      <PopupComponent
        headerMsg={`${selectedClubInfo?.name} 연단체 규정`}
        type="back"
        content={
          <PopupContainer>
            <div className="md">
              <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                {selectedClubInfo?.rules}
              </Markdown>
            </div>
          </PopupContainer>
        }
      />
    </>
  );
}

const PopupContainer = styled.div``;

const Container = styled.div`
  width: 100%;
  min-height: 314px;
  background: #fdfdfd;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0 auto;

  /* Main Content */
  .main-content {
    padding: 0 16px 24px;
  }

  .approval-header {
    margin: 4px;
    margin-top: 10px;
  }

  .approval-text {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .approval-count {
    color: #f97000;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  /* Reservation Cards */
  .reservation-card {
    border: 0.5px solid #d1d5d8;
    border-radius: 6px;
    background: #fdfdfd;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    margin-bottom: 16px;
  }

  .card-header {
    padding: 11px 16px;
    border-bottom: 0.5px solid #d1d5d8;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .golf-course-name {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin: 0;
  }

  .status-badge {
    padding: 4px 6px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  .status-badge.approved {
    background: #e1f4f3;
    color: #004b49;
  }

  .status-badge.modified {
    background: #fff3cd;
    color: #856404;
  }

  .status-badge.reviewing {
    background: #79818a;
    color: #fdfdfd;
  }

  .status-badge.unavailable {
    background: #d1d5d8;
    color: #fdfdfd;
  }

  .card-info {
    padding: 16px;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .info-label {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .info-value {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .golf-course-note {
    color: #79818a;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    margin-top: 16px;
  }

  /* Schedule Details */
  .schedule-details {
    background: #f0f0f4;
    border-radius: 6px;
    margin: 16px;
  }

  .schedule-header {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .schedule-title {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .chevron-icon {
    transform: rotate(-180deg);
    transition: transform 0.2s ease;
  }

  .chevron-icon.expanded {
    transform: rotate(0deg);
  }

  .schedule-info {
    padding: 10px;
    border-top: 0.5px solid #d1d5d8;
  }

  .schedule-section {
    margin-bottom: 24px;
  }

  .section-title {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0 0 8px 0;
  }

  .section-content {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin: 4px 0;
  }

  .round-details {
    margin-bottom: 24px;
  }

  .round-item {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #d1d5d8;
  }

  .round-item:last-child {
    border-bottom: none;
  }

  .round-date {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0 0 12px 0;
  }

  .round-pricing {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .pricing-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pricing-label {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .pricing-value {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .facility-section,
  .game-section {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #d1d5d8;
  }

  .facility-info,
  .game-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
  }

  .facility-row,
  .game-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .facility-label,
  .game-label {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .facility-value,
  .game-value {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .notice-section {
    margin-bottom: 24px;
  }

  .notice-content {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    margin: 8px 0;
  }

  .contact-section {
    margin-top: 24px;
  }

  .contact-info {
    color: #007bff;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0 0 12px 0;
  }

  .disclaimer {
    color: #79818a;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    margin: 0;
  }

  .confirm-button {
    width: 100%;
    height: 50px;
    background: #004b49;
    border: none;
    border-radius: 10px;
    color: #fdfdfd;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    margin: 16px;
    width: calc(100% - 32px);
    transition: background-color 0.2s ease;
  }

  .confirm-button:hover {
    background: #003937;
  }

  .confirm-button:disabled {
    background: #d1d5d8;
    cursor: not-allowed;
  }

  /* Status Cards */
  .status-card {
    padding-bottom: 16px;
  }

  .status-message {
    color: #79818a;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    padding: 0 16px;
    margin: 8px 0 0 0;
  }

  .ani-box {
    > div {
      max-width: 250px;
    }
    min-width: 1px;
  }

  .bottom-section {
    display: flex;
    .check-line {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      gap: 10px;
      font-size: 14px;
      input.book-agree {
        width: 20px;
        transform: scale(1.5);
      }
      > p {
        flex: 1;
      }
    }
  }
  .bottom-notice {
    padding: 20px 10px;
    background-color: ${colors.gray.third};
  }

  /* New Modal Styles */
  .modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 2000;
  }

  .modal-sheet {
    width: 100%;
    max-width: 400px;
    max-height: calc(100% - 100px);
    min-height: auto;
  }

  .modal-content {
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 28px 16px;
    width: 100%;
    min-height: auto;
    box-sizing: border-box;
    border-radius: 10px 10px 0 0;
    background: #fdfdfd;
  }

  .header-section {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .check-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .check-circle-svg {
  }

  .header-title {
    color: #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    flex: 1;
  }

  .disclaimer-text {
    color: #79818a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    height: 42px;
  }

  .warning-section {
    width: 100%;
    display: flex;
    padding: 8px;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 6px;
    background: #f0f0f4;
    box-sizing: border-box;
    min-height: auto;
    height: auto;
  }

  .warning-text {
    color: #79818a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    width: 100%;
  }

  .regulation-button {
    min-width: 71px;
    display: flex;
    padding: 4px 6px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    border: 0.5px solid #79818a;
    background: #fdfdfd;
    height: 20px;
    color: #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    cursor: pointer;
  }

  .regulation-button:hover {
    background: #f8f8f8;
  }

  .cta-button {
    display: flex;
    width: 100%;
    min-height: 60px;
    height: max(60px, 8vh);
    padding: 19px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #d1d5d8;
    color: #fdfdfd;
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    border: none;
    cursor: not-allowed;
    box-sizing: border-box;
    transition: all 0.2s ease;
  }

  .cta-button.active {
    background: var(--Teeshot-Primary-Color-Teeshot-Green, #004b49);
    cursor: pointer;
  }

  .cta-button.active:hover {
    background: #003937;
  }

  .checkbox-section {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .checkbox-section input.book-agree {
    width: 20px;
    height: 20px;
    transform: scale(1.2);
  }

  .checkbox-text {
    color: #1a1a1a;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }
`;

const ReqContent = styled.div`
  overflow: auto;
  .img-box {
    padding: 5px;
    img {
      width: 100%;
    }
  }
`;
const MonthButtonContainer = styled.div`
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  align-items: start;
  gap: 5px 0px;
`;

const MonthButton = styled.div`
  display: flex;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #fff;
  background-color: #000000;
  border-radius: 6px;
`;

const TextWeight700 = styled.div`
  padding: 6px;
  font-weight: 700;
  font-size: 14px;
`;
